import { Button, Flex, Typography } from "antd"

export const WithdrawalInFiatCurrencyStepUI = () => {
  return (
    <Flex vertical>
      <Typography.Text>
        Once your bank details have been added, you can submit a fiat withdrawal
        request.
      </Typography.Text>

      <div>
        <span style={{ opacity: 1 }}>⏳</span>
        <Typography.Text>
          Processing time: On average, withdrawals are processed within{" "}
        </Typography.Text>
      </div>
      <Typography.Text>
        T+1 business day, depending on the bank.
      </Typography.Text>
    </Flex>
  )
}
